import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

// import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'block',
      width: '100%',
      padding: [Spacings.s48, Spacings.s0],
      overflow: 'hidden',
    },
    title: {
      marginBottom: Spacings.s24,
      fontSize: FontSizes.s24,
      lineHeight: LineHeights.l36,
      color: TextColors.base,
      textAlign: 'center',

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        marginBottom: Spacings.s16,
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l24,
      },
    },
    carouselWrapper: {
      '&&': {
        height: 220,
        minHeight: 220,

        // // [mediaQuery(BreakPoints.Small)]: {
        // '@media screen and (max-width: 766px)': {
        //   height: 180,
        //   minHeight: 180,
        // },

        // [mediaQuery(766)]: {
        '@media screen and (max-width: 766px)': {
          height: 100,
          minHeight: 100,
        },
      },
    },

    // SKELETON
    titleFallback: {
      height: 36,
      maxWidth: 570,
      margin: [Spacings.s0, 'auto', Spacings.s24],
    },
    sliderFallback: {
      display: 'flex',
      justifyContent: 'space-around',
      height: 220,

      '& > i': {
        width: 160,
        marginRight: Spacings.s8,
        border: `2px solid ${BackgroundColors.tint3}`,
      },
    },
  }),
  {
    name: 'image-slider-dynamic-templates',
  },
);

export default useStyles;
